import React, { useContext, useRef, useState } from 'react';
import { BsSearch } from 'react-icons/bs';
import { FiUser } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import { UserContext } from '../App';
import logo from '../images/happytimes.png';
import SearchInput from './search/SearchInput';

export default function Header() {
  const user = useContext(UserContext);
  const [searchOpen, setSearchOpen] = useState(false);
  const searchTrigger = useRef(null);
  const closeSearch = () => {
    setSearchOpen(false);
    requestAnimationFrame(() => searchTrigger.current?.focus());
  };
  return <header className="site-header">
    <div className="site-header-inner">
      <Link to="/" className="site-brand" aria-label="HappyTimes home">
        <span className="site-brand-mark"><img src={logo} alt="" width="32" height="32" /></span>
        <span className="site-brand-copy"><span className="site-brand-name">HappyTimes</span><span className="site-brand-caption">Memes & community</span></span>
      </Link>
      <button ref={searchTrigger} className="site-search-trigger" type="button" onClick={() => setSearchOpen(true)} aria-label="Search people and creators" aria-haspopup="dialog" aria-expanded={searchOpen}>
        <BsSearch aria-hidden="true" /><span className="site-search-desktop">Search people and creators</span><span className="site-search-mobile">Search</span>
      </button>
      <Link to="/account" className="site-account-link" aria-label={user ? 'Your account' : 'Sign in'}>
        <FiUser aria-hidden="true" /><span>{user ? 'Your account' : 'Sign in'}</span>
      </Link>
    </div>
    {searchOpen && <SearchInput setSearchModal={closeSearch} />}
  </header>;
}
